<ng-container *ngIf="dataTransfer">
	<h3>{{ dataTransfer.title ? dataTransfer.title : 'DATOS DE LA TRANSFERENCIA' }}</h3>
	<app-alert
		title="Atención"
		message="Revise los datos antes de validar la transferencia."
		type="warn"
		[showCloseButton]="true"
	></app-alert>
	<div class="datos_transferencia datos_conf_deposito clearfix">
		<div class="full_celda">
			<app-tag-account-transfer [item]="item" *ngFor="let item of dataTransfer.dataTransfer"></app-tag-account-transfer>
		</div>
	</div>
</ng-container>
